// extracted by mini-css-extract-plugin
module.exports = {"transactions":"TransactionList_transactions__yIzPA"};